import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Subscription, timer } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { ToastNotificationsManagerService } from '../toast-notifications-manager/toast-notifications-manager.service';

const LONG_REQUEST_MS = 5000;
const TOAST_ID = 'long-running-request-toast';

let activeRequests = 0;
let timerSub: Subscription | null = null;
let toastShown = false;

export const longRequestInterceptor: HttpInterceptorFn = (req, next) => {
  const toastService = inject(ToastNotificationsManagerService);

  activeRequests++;

  // Start timer only for the first active request
  if (activeRequests === 1)
    timerSub = timer(LONG_REQUEST_MS).subscribe(() => {
      if (activeRequests > 0 && !toastShown) {
        toastShown = true;
        toastService.addNew({
          id: TOAST_ID,
          type: 'info',
          hideAfterMs: 60000,
          content:
            'Your request is still being processed. Please wait while the operation is in progress.',
        });
      }
    });

  return next(req).pipe(
    finalize(() => {
      activeRequests--;

      // When all requests finish → cleanup
      if (activeRequests === 0) {
        timerSub?.unsubscribe();
        timerSub = null;

        if (toastShown) {
          toastService.removeNotif(TOAST_ID);
          toastShown = false;
        }
      }
    }),
  );
};
